import { Camera } from "lucide-react";

/**
 * Elegant photo placeholder. When an `accent` color is supplied, the outer
 * frame uses that color so it matches the card's top trim. Otherwise it falls
 * back to the weathered wood frame.
 */
export default function PhotoPlaceholder({ label, aspect = "square", className = "", accent }) {
  const aspectClass =
    aspect === "wide" ? "aspect-[16/10]" : aspect === "tall" ? "aspect-[3/4]" : "aspect-square";

  return (
    <div
      data-testid={`photo-placeholder-${label.replace(/\s+/g, "-").toLowerCase()}`}
      className={`relative ${aspectClass} w-full overflow-hidden ${className}`}
    >
      {/* outer frame — matches accent color when provided */}
      {accent ? (
        <div
          className="absolute inset-0 rounded-sm shadow-md"
          style={{
            background: `linear-gradient(180deg, ${accent} 0%, ${accent}cc 100%)`,
          }}
        />
      ) : (
        <div className="absolute inset-0 wood rounded-sm shadow-md" />
      )}
      {/* inner parchment */}
      <div className="absolute inset-[10px] parchment-deep rounded-[2px] flex flex-col items-center justify-center text-center px-6 border border-[#8D6E63]/30 shadow-inner">
        <div className="absolute inset-3 border border-dashed border-[#8D6E63]/35 rounded-[2px]" />
        <Camera size={26} className="text-[#8D6E63] mb-3 opacity-75" />
        <p className="font-script text-3xl text-[#4B3A2F] leading-none">
          {label}
        </p>
        <p className="mt-2 text-xs uppercase tracking-[0.25em] text-[#8D6E63]">
          Photo Placeholder
        </p>
      </div>
    </div>
  );
}
